import React, { Component, PureComponent } from "react";
import { EmailAddress } from "../../core/api/models";
import { DropdownList } from "react-widgets";

interface Props {
  placeholder?: string;
  onChange: (val: EmailAddress[]) => void;
  value?: EmailAddress[];
  className?: string;
  isEdit?: boolean;
  onUpdate?: (val: EmailAddress[]) => void;
  disabled?: boolean;
}

interface SingleProps {
  onChange: (val: EmailAddress) => void;
  onRemove: () => void;
  value: EmailAddress;
  isEdit?: boolean;
  index: number;
  totalItems: number;
  disabled?: boolean;
}

interface State {
  emailAddress: EmailAddress[];
}

export enum EmailTypes {
  Business = "Business",
  Sales = "Sales",
  HeadQuarters = "HeadQuaters", // Note: keeping the original spelling
  Support = "Support"
}

const EmailType = [
  { name: "Business", value: EmailTypes.Business },
  { name: "Sales", value: EmailTypes.Sales },
  { name: "HeadQuarters", value: EmailTypes.HeadQuarters },
  { name: "Support", value: EmailTypes.Support },
];

class SinglePhoneInput extends PureComponent<SingleProps> {
  setAsPrimary = () => {
    if (this.props.disabled) {
      return;
    }
    const { value, totalItems } = this.props;
    if (totalItems > 1 && !value.isPrimary) {
      value.isPrimary = !value.isPrimary;
      this.props.onChange(value);
    }
  };

  setType = (type: { name: string; value: string }) => {
    const { value } = this.props;
    value.emailType = type.value;
    this.props.onChange(value);
  };

  setEmail = (e: { target: { value: string } }) => {
    const { value } = this.props;
    value.email = e.target.value;
    this.props.onChange(value);
  };

  render() {
    return (
      <div className="row gutter-5 mb-2 w-100">
        <div className="col input-group email-group">
          <input
            type="text"
            placeholder="Email"
            className="font-sm font-weight-semibold form-control border-right-0"
            value={this.props.value.email}
            name=""
            id=""
            onChange={this.setEmail}
            disabled={this.props.disabled}
          />
          <div className="col-4 p-0">
            <DropdownList
              value={this.props.value.emailType}
              defaultValue={this.props.value.emailType}
              data={EmailType}
              textField={"name"}
              valueField={"value"}
              placeholder={"Select Type"}
              onChange={this.setType}
              disabled={this.props.disabled}
            />
          </div>
        </div>

        <div className="col-auto">
          <div
            onClick={this.setAsPrimary}
            className={`set-primary form-control font-sm h-100 px-2 d-flex align-items-center justify-content-center 
            ${this.props.disabled ? "" : "cursor-pointer"}            
             ${this.props.value.isPrimary ? "text-shamrock" : "text-gray-400"}`}
          >
            <i className="icon-tick"></i>
          </div>
        </div>
        {this.props.index > 1 && (
          <div className="col-auto d-flex">
            <i
              onClick={this.props.onRemove}
              className="icon-bin-fill cursor-pointer align-self-center font-lg text-gray-700"
            ></i>
          </div>
        )}
      </div>
    );
  }
}

// tslint:disable-next-line: max-classes-per-file
class OtpInput extends Component<Props, State> {
  static defaultProps = {
    // tslint:disable-next-line: no-console
    onChange: (otp: number): void => console.log(otp),
    value: "",
  };
  componentDidUpdate(prevProps: Props) {
    if (prevProps.value !== this.props.value) {
      if (!this.props.value?.length) {
        this.setState({
          emailAddress: [
            {
              email: "",
              emailType: "Sales",
              isPrimary: true,
            },
          ],
        });
      }
    }
  }
  state = {
    emailAddress:
      this.props.value && this.props.value.length > 0
        ? this.props.value
        : [
            {
              email: "",
              emailType: "Sales",
              isPrimary: true,
            },
          ],
  };

  addMorePhone = () => {
    const { emailAddress } = this.state;
    emailAddress.push({
      email: "",
      emailType: "Sales",
      isPrimary: false,
    });
    this.setState({ emailAddress });
  };

  handleOnChange = (email: EmailAddress, index: number) => {
    const { onChange } = this.props;
    let { emailAddress } = this.state;
    if (email.isPrimary) {
      emailAddress = emailAddress.length
        ? emailAddress.map((d: EmailAddress) => {
            return {
              ...d,
              isPrimary: false,
            };
          })
        : [];
    }
    emailAddress[index] = email;
    if (!emailAddress.find((x) => x.isPrimary)) {
      emailAddress[0].isPrimary = true;
    }
    this.setState({ emailAddress });
    onChange(emailAddress);
  };

  handleOnRemove = (index: number) => {
    const { onChange } = this.props;
    const { emailAddress } = this.state;
    emailAddress.splice(index, 1);
    if (!emailAddress.find((x) => x.isPrimary)) {
      emailAddress[emailAddress.length - 1].isPrimary = true;
    }
    this.setState({ emailAddress });
    onChange(emailAddress);
    if (this.props.isEdit && this.props.onUpdate) {
      this.props.onUpdate(emailAddress);
    }
  };

  renderInputs = () => {
    const { emailAddress } = this.state;

    const inputs = [];

    for (let i = 0; i < emailAddress.length; i++) {
      inputs.push(
        <SinglePhoneInput
          onChange={(value: EmailAddress) => this.handleOnChange(value, i)}
          value={emailAddress[i]}
          isEdit={this.props.isEdit}
          onRemove={() => this.handleOnRemove(i)}
          index={emailAddress.length}
          totalItems={emailAddress.length}
          disabled={this.props.disabled}
        />
      );
    }

    return inputs;
  };

  render() {
    return (
      <>
        {this.renderInputs()}
        <div className="w-100"></div>
        {!this.props.disabled && (
          <button
            type="button"
            className="btn btn-link font-sm p-0 font-weight-semibold"
            onClick={this.addMorePhone}
          >
            + add one more
          </button>
        )}
      </>
    );
  }
}

export default OtpInput;
